import { Component, Vue, Prop } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { EnglishRules, Rules } from '@/support/ValidationRules';
import { SupplierSizePack } from '@/models/SupplierSizePack';
import { cloneDeep } from 'lodash';

@Component<SupplierSizePackCreateOrUpdateDialog>({})
export default class SupplierSizePackCreateOrUpdateDialog extends Vue {
  @Prop({ default: undefined })
  protected originalSupplierSizePack!: SupplierSizePack;

  protected isFormValid: boolean = false;

  protected isLoading: boolean = false;

  protected supplierSizePack: SupplierSizePack = new SupplierSizePack();

  protected rules: Rules = EnglishRules;

  protected mounted(): void {
    this.initialize();
  }

  protected initialize(): void {
    if (!this.originalSupplierSizePack) { return; }

    this.supplierSizePack = cloneDeep(this.originalSupplierSizePack);

    this.supplierSizePack.size_ids = this.supplierSizePack.sizes
      ? this.supplierSizePack.sizes.map((supplierSize) => supplierSize.id || '')
      : [];
  }

  protected close(): void {
    this.$emit('input', false);
  }

  protected async onSaveButtonClick(): Promise<void> {
    if (! this.canSaveSupplierSizePack) { return; }

    this.isLoading = true;

    const supplierSizePack = this.originalSupplierSizePack
      ? await this.update()
      : await this.create();

    if (supplierSizePack) {
      this.originalSupplierSizePack
        ? this.$emit('sizeUpdated', supplierSizePack)
        : this.$emit('sizeCreated', supplierSizePack);

      this.close();
    }

    this.isLoading = false;
  }

  protected async update(): Promise<null | SupplierSizePack> {
    if (! this.supplierSizePack) { return null; }

    const supplierSizePack = await this.supplierSizePack
      .update()
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
        return null;
      });

    return supplierSizePack;
  }

  protected async create(): Promise<null | SupplierSizePack> {
    const supplierSizePack = await this.supplierSizePack
      .create()
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
        return null;
      });

    return supplierSizePack;
  }

  protected get canSaveSupplierSizePack() {
    return this.isFormValid && ! this.isLoading;
  }

  protected get saveButtonText(): string {
    return this.originalSupplierSizePack
      ? 'Edit'
      : 'Add';
  }
}
